import React from 'react';
import { SummaryForm, OfferingsForm, FormWrapper } from '../components/Forms';
import useSummaryAndOfferings from '../hooks/useSummaryAndOfferings';
import Tabs from '../components/ui/Tabs';

const ProfilePage = () => {
  const {
    profileSummary,
    summaryLoading,
    summaryError,
    profileOfferings,
    offeringsLoading,
    offeringsError,
    handleSaveSummary,
    handleSaveOffering,
    handleDeleteOffering,
    updateSummaryMutation,
    updateOfferingMutation,
  } = useSummaryAndOfferings();

  return (
    <div className='min-h-screen'>
      <div className='max-w-full mx-auto px-4 py-8'>
        <Tabs
          className='lg:hidden mb-6'
          tabs={[
            { id: 'summary', title: 'Summary' },
            { id: 'offerings', title: 'Offerings' },
          ]}
        >
          <FormWrapper
            tabId='summary'
            isLoading={summaryLoading}
            error={summaryError}
            data={profileSummary}
            errorMessage='Failed to load profile summary'
          >
            <SummaryForm
              initialData={profileSummary}
              onSave={handleSaveSummary}
              isLoading={updateSummaryMutation.isPending}
            />
          </FormWrapper>

          {/* Offerings Section */}
          <FormWrapper
            isLoading={offeringsLoading}
            error={offeringsError}
            data={profileOfferings}
            errorMessage='Failed to load offerings'
            tabId='offerings'
          >
            <OfferingsForm
              initialData={profileOfferings || []}
              onSave={handleSaveOffering}
              isLoading={updateOfferingMutation.isPending}
              onDelete={handleDeleteOffering}
            />
          </FormWrapper>
        </Tabs>
        <div className='hidden lg:grid lg:grid-cols-2 gap-6 p-3 bg-white/60 backdrop-blur-md rounded-2xl shadow-xl border border-white/20'>
          {/* Summary Section */}
          <FormWrapper
            isLoading={summaryLoading}
            error={summaryError}
            data={profileSummary}
            errorMessage='Failed to load profile summary'
          >
            <SummaryForm
              initialData={profileSummary}
              onSave={handleSaveSummary}
              isLoading={updateSummaryMutation.isPending}
            />
          </FormWrapper>

          {/* Offerings Section */}
          <FormWrapper
            isLoading={offeringsLoading}
            error={offeringsError}
            data={profileOfferings}
            errorMessage='Failed to load offerings'
          >
            <OfferingsForm
              initialData={profileOfferings || []}
              onSave={handleSaveOffering}
              isLoading={updateOfferingMutation.isPending}
              onDelete={handleDeleteOffering}
            />
          </FormWrapper>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
